import { SaisieInfosSouscripteur } from './../../models/form-state.model';

export interface SubscriberState {
  subscriber?: SaisieInfosSouscripteur;
  isValid: boolean;
  isTheSameAsInsured?: boolean;
}

export const initialState: SubscriberState = {
  isValid: false
};
